import { render, staticRenderFns } from "./RouteBuilderOrderLocationCard.vue?vue&type=template&id=61587c13&"
import script from "./RouteBuilderOrderLocationCard.vue?vue&type=script&lang=js&"
export * from "./RouteBuilderOrderLocationCard.vue?vue&type=script&lang=js&"
import style0 from "./RouteBuilderOrderLocationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports